export default __webpack_public_path__ + "static/media/Chrome for Android.cb9e2605.svg";